module.exports = __webpack_public_path__ + "img/needle-sideview.fbc8adeb.png";